export default __webpack_public_path__ + "static/media/V860_CoC.3f2ea53f.pdf";